
import React from 'react'
import { Container } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";
import Section1 from "../../containers/HomePage/Section1/Section1"
import Section2 from "../../containers/HomePage/Section2/Section2"
import Section3 from "../../containers/HomePage/Section3/Section3"
import Section4 from '../../containers/HomePage/Section4/Section4';
import Section5 from '../../containers/HomePage/Section5/Section5';
const HomePage = () => {
    const { t } = useTranslation();
    return  <div className="main-cls">
        <Container fluid className="bg-black p-1">
            <Section1 />
        </Container>
        <Container fluid className="bg-whtie p-1">
            <Section2 />
        </Container>
        <Container fluid className="bg-whtie p-1">
            <Section3 />
        </Container>
        <Container fluid className="bg-whtie p-1">
            <Section4 />
        </Container>
        <Container fluid className="bg-whtie p-1">
            <Section5 />
        </Container>
    </div>
}
export default HomePage